import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulInfo,
    addSinglePrintfulInfo,
    updateSinglePrintfulInfo,
    getSinglePrintfulInfo,
    searchPrintfulInfo,
    searchPrintfulInfoWithSearchCriteria,
    preparePrintfulInfoList
}

const collectionName = 'printful-info';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulInfo = (printfulInfo) => {
    return Promise.map(printfulInfo, async printfulInfo => {
        await addSinglePrintfulInfo(printfulInfo);
    });
}

const addSinglePrintfulInfo = (printfulInfo) => {
    printfulInfo.createdAt = new Date();
    printfulInfo.updatedAt = printfulInfo.createdAt;
    return addDoc(collectionReference, printfulInfo);
}

const updateSinglePrintfulInfo = (printfulInfo) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulInfo.id);
    printfulInfo.updatedAt = new Date();
    return setDoc(documentReference, printfulInfo);
}

const getSinglePrintfulInfo = async (printfulInfoId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulInfoId);
    const printfulInfoDoc = await getDoc(documentReference);
    return prepareSinglePrintfulInfo(printfulInfoDoc);
}

const searchPrintfulInfo = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulInfoResult = await getDocs(searchQuery);
    return preparePrintfulInfoList(printfulInfoResult);
}

const searchPrintfulInfoWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulInfoWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulInfoResult = await getDocs(searchQuery);
    return preparePrintfulInfoList(printfulInfoResult);
}

const preparePrintfulInfoList = (printfulInfoResult) => {
    const printfulInfoList = [];

    _.forEach(printfulInfoResult.docs, printfulInfoDoc => {
        printfulInfoList.push(prepareSinglePrintfulInfo(printfulInfoDoc));
    });

    return printfulInfoList;
}


const prepareSinglePrintfulInfo = (printfulInfoDoc) => {
    if (!printfulInfoDoc.exists()) {
        return {};
    }

    const printfulInfo = printfulInfoDoc.data();
    printfulInfo.id = printfulInfoDoc.id;
    return printfulInfo;
}
